export enum FooterActionEnum {
  SAVE_SHIPMENT = 'SAVE_SHIPMENT',
  DELETE_SELECTED_SHIPMENTS = 'DELETE_SELECTED_SHIPMENTS',

  PRINT_ORDER_LABELS = 'PRINT_ORDER_LABELS',
  PRINT_ORDER_WAYBILL = 'PRINT_ORDER_WAYBILL',
  PRINT_ORDER_RECEIPT_LIST = 'PRINT_ORDER_RECEIPT_LIST',
  PRINT_ORDER_PICKING_LIST = 'PRINT_ORDER_PICKING_LIST',
  PRINT_ORDER_RECEIPT = 'PRINT_ORDER_RECEIPT',

  SAVE_SETTINGS = 'SAVE_SETTINGS',

  SAVE_ADDRESS = 'SAVE_ADDRESS',
  DELETE_SELECTED_ADDRESSES = 'DELETE_SELECTED_ADDRESSES',

  PRINT_LABELS_FOR_SELECTED_SHIPMENTS = 'PRINT_LABELS_FOR_SELECTED_SHIPMENTS',
  PRINT_WAYBILL_FOR_SELECTED_SHIPMENTS = 'PRINT_WAYBILL_FOR_SELECTED_SHIPMENTS',
  PRINT_RECEIPT_LIST_FOR_SELECTED_SHIPMENTS = 'PRINT_RECEIPT_LIST_FOR_SELECTED_SHIPMENTS',
  PRINT_PICKING_LIST_FOR_SELECTED_SHIPMENTS = 'PRINT_PICKING_LIST_FOR_SELECTED_SHIPMENTS',

  GO_TO_CREATE_CONSIGNMENT = 'GO_TO_CREATE_CONSIGNMENT',
  GO_TO_CREATE_CONSIGNMENT_SEARCH_RESULT = 'GO_TO_CREATE_CONSIGNMENT_SEARCH_RESULT',
  GO_TO_CREATE_CONSIGNMENT_ORDER_SUMMARY = 'GO_TO_CREATE_CONSIGNMENT_ORDER_SUMMARY',
  GO_TO_CREATE_CONSIGNMENT_ORDER_COMPLETE = 'GO_TO_CREATE_CONSIGNMENT_ORDER_COMPLETE',
  GO_TO_BOOKED_SHIPMENTS = 'GO_TO_BOOKED_SHIPMENTS',

  GO_FORWARD = 'GO_FORWARD',
  GO_BACKWARD = 'GO_BACKWARD',
}



// WEBPACK FOOTER //
// ./src/app/model/footer-action.enum.ts